import { SelectCode } from "./select-code.model";

export class SelectImage extends SelectCode {
  imgPath: string | null = null;
}

